var _clipPath, _mask, _mask2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPourwallLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 58,
    viewBox: "0 0 378 58",
    width: 378,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h378v58h-378z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 58,
    maskUnits: "userSpaceOnUse",
    width: 58,
    x: 91,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m149 0h-58v58h58z",
    fill: "#f8e71c"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    height: 58,
    maskUnits: "userSpaceOnUse",
    width: 58,
    x: 91,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m149 0h-58v58h58z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m17.2008 39.8136v18.1864h-17.2008v-58h20.5274c2.2718 0 4.5706.32768 6.8965.983051 2.3259.655369 4.4219 1.747639 6.2881 3.276839 1.8661 1.5292 3.3806 3.54989 4.5436 6.06211 1.1629 2.5123 1.7444 5.6526 1.7444 9.4209 0 3.6046-.5544 6.6766-1.6633 9.2161-1.1088 2.5396-2.5558 4.6149-4.3408 6.226s-3.8133 2.7853-6.0851 3.5226c-2.2719.7373-4.5707 1.106-6.8966 1.106zm-.2008-24.8136v11h2.2195c1.1951 0 2.2907-.5077 3.2866-1.5231s1.4939-2.3974 1.4939-4.1461c0-1.918-.498-3.2859-1.4939-4.1039-.9959-.8179-2.0915-1.2269-3.2866-1.2269zm29.6622 1.9037c1.1081-3.5668 2.7027-6.6038 4.7837-9.11092 2.0811-2.50714 4.6081-4.4327 7.5811-5.77674 2.973-1.344033 6.2973-2.01604 9.973-2.01604s7 .672007 9.973 2.01604c2.973 1.34404 5.5 3.2696 7.5811 5.77674 2.081 2.50712 3.6756 5.54412 4.7837 9.11092 1.1082 3.5669 1.6622 7.5473 1.6622 11.9412 0 4.394-.554 8.3873-1.6622 11.98-1.1081 3.5927-2.7027 6.6555-4.7837 9.1885-2.0811 2.533-4.6081 4.4973-7.5811 5.893s-6.2973 2.0936-9.973 2.0936-7-.6979-9.973-2.0936-5.5-3.36-7.5811-5.893c-2.081-2.533-3.6756-5.5958-4.7837-9.1885-1.1082-3.5927-1.6622-7.586-1.6622-11.98 0-4.3939.554-8.3743 1.6622-11.9412zm16.3378 12.0145c0 3.7611.4868 6.8816 1.4605 9.3617s2.4869 3.7201 4.5395 3.7201 3.5658-1.24 4.5395-3.7201 1.4605-5.6006 1.4605-9.3617c0-3.761-.4868-6.8542-1.4605-9.2798s-2.4869-3.6384-4.5395-3.6384-3.5658 1.2128-4.5395 3.6384-1.4605 5.5188-1.4605 9.2798zm104.336 8.2739h-1.461v20.8079h-16.875v-58h21.338c3.299 0 6.179.436907 8.64 1.31073 2.461.87383 4.476 2.12994 6.045 3.76837 1.568 1.63842 2.745 3.61816 3.529 5.9393.784 2.3211 1.176 4.9289 1.176 7.8234 0 1.9661-.216 3.7411-.649 5.3249-.432 1.5838-.973 2.9901-1.622 4.2189s-1.38 2.2528-2.191 3.072-1.623 1.42-2.434 1.8023l9.168 24.7401h-18.579zm-1.336-24.1921v10h1.367c.456 0 .962-.0672 1.519-.2016s1.063-.3898 1.519-.7661c.456-.3764.836-.8871 1.139-1.5323.304-.6452.456-1.4785.456-2.5 0-1.0753-.139-1.9355-.418-2.5806-.278-.6452-.633-1.156-1.063-1.5323s-.886-.6183-1.367-.7258-.924-.1613-1.329-.1613zm54.65 45h-17.151l-10.499-58h17.712l3.847 33.9153h.4l4.088-33.9153h15.628l4.408 33.9153h.24l3.767-33.9153h16.91l-10.659 58h-17.151l-5.69-32.2768h-.24zm63.8-8.0282h-9.695l-1.51 8.0282h-16.245l10.309-58h25.302l10.389 58h-17.04zm-7.45-12.9718h6l-2.75-19h-.333zm31-37h17.476v41.6158h14.524v16.3842h-32zm38 0h17.476v41.6158h14.524v16.3842h-32z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m102.6 19.3333h34.8l-3.867 32.8666h-27.067z",
    fill: "#f8e71c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m136.97 5.8-3.437 46.4h-27.064l-3.439-46.4zm-40.1702-5.8h46.4002l-3.867 58h-38.667z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPourwallLogo);
export default __webpack_public_path__ + "static/media/pourwall-logo.408c8ea965738dea6b53b993efc322d9.svg";
export { ForwardRef as ReactComponent };